import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { RevisionDelegateRejectPathParameters } from 'api/actions/revision-delegate-reject/revision-delegate-reject-path-parameters';
import { RevisionDelegateRejectResponse } from 'api/actions/revision-delegate-reject/revision-delegate-reject-response';

type RevisionDelegateRejectQueryParameters = Record<string, any>;

/**
 * The path of the RevisionDelegateReject action.
 */
export const revisionDelegateRejectActionPath = new SweetPath<keyof RevisionDelegateRejectPathParameters>(
  '/api/revision/delegate-reject/{revisionId}',
  { path: '{param}' }
);

/**
 * Creates a contextualized RevisionDelegateReject actions.
 */
export default function createRevisionDelegateRejectAction(axios: AxiosInstance) {
  return function revisionDelegateRejectAction({
    headers = {},
    parameters,
    query = {},
  }: {
    headers?: AxiosRequestConfig<any>['headers'];
    parameters: RevisionDelegateRejectPathParameters;
    query?: RevisionDelegateRejectQueryParameters;
  }) {
    const path = revisionDelegateRejectActionPath.insert(parameters);

    return axios.request<RevisionDelegateRejectResponse, RevisionDelegateRejectResponse>({
      method: 'post',
      url: path,
      params: query,

      headers,
    });
  };
}
